document.addEventListener("DOMContentLoaded", function () {
    const slider = {
        currentSlide: 0,
        container: document.querySelector(".gallery-container"),
        slides: document.querySelectorAll(".gallery-item"),
        touchStartX: 0,
        touchEndX: 0,

        init() {
            if (!this.slides.length) return;

            // Create navigation elements
            this.createNavigation();

            // Set initial position and state
            this.updateSlider();

            // Add event listeners
            document
                .querySelector(".gallery-prev")
                .addEventListener("click", () => this.prevSlide());
            document
                .querySelector(".gallery-next")
                .addEventListener("click", () => this.nextSlide());

            // Add touch event listeners
            this.addTouchListeners();

            // Add click event listeners to slides
            this.addClickListeners();
        },

        createNavigation() {
            const nav = document.querySelector(".gallery-navigation");
            nav.insertAdjacentHTML(
                "afterbegin",
                `
                <div class="gallery-fraction">1 / ${this.slides.length}</div>
            `
            );
        },

        updateSlider() {
            // Calculate the offset to align active slide to the left edge
            const slideWidth = this.slides[0].offsetWidth;
            const offset = -this.currentSlide * slideWidth;

            document.querySelector(
                ".gallery-track"
            ).style.transform = `translateX(${offset}px)`;

            // Update fraction
            const fraction = document.querySelector(".gallery-fraction");
            fraction.textContent = `${this.currentSlide + 1} / ${
                this.slides.length
            }`;

            // Update active states
            this.slides.forEach((slide, index) => {
                slide.classList.toggle("active", index === this.currentSlide);
                slide.classList.toggle("next", index === this.currentSlide + 1);
            });
        },

        nextSlide() {
            this.currentSlide++;
            if (this.currentSlide >= this.slides.length) {
                // When we reach the end, quickly reset to first slide
                this.currentSlide = 0;
                document.querySelector(".gallery-track").style.transition =
                    "none";
                this.updateSlider();
                // Force a reflow
                document.querySelector(".gallery-track").offsetHeight;
                // Re-enable transitions
                document.querySelector(".gallery-track").style.transition =
                    "transform 0.3s ease-out";
            }
            this.updateSlider();
        },

        prevSlide() {
            this.currentSlide--;
            if (this.currentSlide < 0) {
                // When we reach the start, quickly reset to last slide
                this.currentSlide = this.slides.length - 1;
                document.querySelector(".gallery-track").style.transition =
                    "none";
                this.updateSlider();
                // Force a reflow
                document.querySelector(".gallery-track").offsetHeight;
                // Re-enable transitions
                document.querySelector(".gallery-track").style.transition =
                    "transform 0.3s ease-out";
            }
            this.updateSlider();
        },

        addTouchListeners() {
            const track = document.querySelector(".gallery-track");

            // Touch events
            track.addEventListener(
                "touchstart",
                (e) => {
                    this.touchStartX = e.changedTouches[0].screenX;
                },
                { passive: true }
            );

            track.addEventListener(
                "touchend",
                (e) => {
                    this.touchEndX = e.changedTouches[0].screenX;
                    this.handleSwipe();
                },
                { passive: true }
            );

            // Mouse events for desktop swipe
            track.addEventListener("mousedown", (e) => {
                this.touchStartX = e.screenX;
                track.style.cursor = "grabbing";

                const handleMouseMove = (moveEvent) => {
                    // Optional: Add real-time dragging effect here if desired
                };

                const handleMouseUp = (upEvent) => {
                    this.touchEndX = upEvent.screenX;
                    this.handleSwipe();
                    track.style.cursor = "grab";

                    // Remove the temporary listeners
                    document.removeEventListener("mousemove", handleMouseMove);
                    document.removeEventListener("mouseup", handleMouseUp);
                };

                // Add temporary listeners for mouse movement and release
                document.addEventListener("mousemove", handleMouseMove);
                document.addEventListener("mouseup", handleMouseUp);
            });

            // Prevent default drag behavior on images
            this.slides.forEach((slide) => {
                const img = slide.querySelector("img");
                if (img) {
                    img.addEventListener("dragstart", (e) =>
                        e.preventDefault()
                    );
                }
            });
        },

        handleSwipe() {
            const swipeThreshold = 50; // Minimum distance to register as a swipe
            const swipeDistance = this.touchEndX - this.touchStartX;

            if (swipeDistance > swipeThreshold) {
                // Swiped right, go to previous slide
                this.prevSlide();
            } else if (swipeDistance < -swipeThreshold) {
                // Swiped left, go to next slide
                this.nextSlide();
            }
        },

        addClickListeners() {
            this.slides.forEach((slide, index) => {
                slide.addEventListener("click", () => {
                    // If clicking the next slide, go to that slide
                    // If clicking the current slide, do nothing (it's already active)
                    // Otherwise, navigate to the clicked slide
                    if (index === this.currentSlide + 1) {
                        this.nextSlide();
                    } else if (index !== this.currentSlide) {
                        this.currentSlide = index;
                        this.updateSlider();
                    }
                    // If clicking the current slide, do nothing
                });
            });
        },
    };

    slider.init();
});
